
export class QuestionnairesXML  {

  content: string;

}
